const initialState = {
  posts: [],
  users: [],
  sports: [],
  type: '',
  athletesOnApp: [],
  fansOnApp: []
};

const browse = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'SET_BROWSE':
      return {
        ...initialState,
        ...payload
      };

    case 'UPDATE_BROWSE':
      return {
        ...state,
        ...payload
      };

    case 'REMOVE_POST':
      return {
        ...state,
        posts: state.posts.filter((post) => post._id !== payload)
      };

    case 'ADD_POSTS_BROWSE':
      return {
        ...state,
        posts: [...state.posts, ...payload]
      };

    case 'ADD_ATHLETES_BROWSE':
      return {
        ...state,
        athletesOnApp: [...(state.athletesOnApp || []), ...payload]
      };

    case 'ADD_FANS_BROWSE':
      return {
        ...state,
        fansOnApp: [...(state.fansOnApp || []), ...payload]
      };

    case 'SET_SPORTS_BROWSE':
      return {
        ...state,
        sports: payload
      };

    case 'SET_TYPE_BROWSE':
      return {
        ...state,
        type: payload
      };

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default browse;
